import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';

/**
 * This component determines which of 2 slots,  "even-year-variant" and "odd-year-variant", display
 * Based on effective date's year being an ODD or EVEN year
 */
@Component({
  selector: 'app-plan-year-content-filter',
  standalone: false,
  templateUrl: './plan-year-content-filter.component.html',
  styleUrl: './plan-year-content-filter.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom
})
export class PlanYearContentFilterComponent implements OnInit, OnDestroy {

  isEvenYear: boolean;

  constructor(private ngRedux: NgRedux<StateStructure>) {}

  ngOnInit() {
    const effectiveDate = this.ngRedux.getState()?.appStates?.EffectiveDate?.effectiveDateYear;
    this.isEvenYear = effectiveDate % 2 === 0;
  }
  
  ngOnDestroy() {}

}